import { CommonFilterSelectOption } from "../components/CommonFilterSelect";

export const countryCodeList: Array<CommonFilterSelectOption> = [
  {
    id: 0,
    label: "JP",
  },
  {
    id: 1,
    label: "US",
  },
  {
    id: 2,
    label: "CA",
  },
  {
    id: 3,
    label: "GB",
  },
  {
    id: 4,
    label: "DE",
  },
  {
    id: 5,
    label: "FR",
  },
  {
    id: 6,
    label: "IT",
  },
  {
    id: 7,
    label: "CN",
  },
  {
    id: 8,
    label: "KR",
  },
  {
    id: 9,
    label: "AU",
  },
  {
    id: 10,
    label: "IN",
  },
  {
    id: 11,
    label: "MX",
  },
  {
    id: 12,
    label: "BR",
  },
  {
    id: 13,
    label: "RU",
  },
  {
    id: 14,
    label: "ES",
  },
];
